module.exports = __webpack_public_path__ + "static/media/Snapshot Vid Script April_1620677053435.9dd9dace.docx";